import clsx from "clsx";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Api } from "~/api";

import styles from "./index.module.scss";

export default function ManagerInstallPrice() {
  const [price, setPrice]: any = useState({});
  const { host } = useSelector((state: any) => state.params);
  const { params: filterParams } = useSelector((state: any) => state.filter);
  const getInstallPrie = async () => {
    setPrice(
      await Api.server.getManagerInstallPrice(
        filterParams.marka[0],
        filterParams.model[0],
        filterParams.kuzov[0],
      ),
    );
  };
  useEffect(() => {
    if (
      filterParams?.marka?.[0] &&
      filterParams?.model?.[0] &&
      filterParams?.kuzov?.[0]
    ) {
      getInstallPrie();
    } else {
      setPrice({});
    }
  }, [filterParams]);

  const [currentHost, setCurrentHost] = useState("msk");
  useEffect(() => {
    const currentHost = host
      .replace("localhost:3000", "msk.farkop.ru")
      .split(".")[0];
    if (["msk", "spb"].includes(currentHost)) {
      setCurrentHost(currentHost);
    }
  }, [host]);

  const cityNane: any = {
    msk: "Москва",
    spb: "Санкт-Петербург",
  };

  return price.msk || price.spb ? (
    <div className={styles.Block}>
      <div className={styles.Selector}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          className={clsx(currentHost === "msk" && styles.SelectorActive)}
          onClick={() => {
            setCurrentHost("msk");
          }}
        >
          Цены в МСК
        </div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          className={clsx(currentHost === "spb" && styles.SelectorActive)}
          onClick={() => {
            setCurrentHost("spb");
          }}
        >
          Цены в СПБ
        </div>
      </div>
      <span>
        Внимание, у вас выбран город{" "}
        <b style={{ color: "red" }}>{cityNane[currentHost]}</b>!
      </span>
      <div className={styles.Table}>
        {price[currentHost]?.map((model: any) => (
          <div key={model.NAME} className={styles.PriceBlock}>
            <div>{model.name}</div>
            <div>
              {model.childs.map((item: any) => (
                <div key={item.name} className={styles.Price}>
                  <div>{reduceWords(item.name)}</div>
                  <div>{item.price.replace("рублей", "руб")}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <a
        target="_blank"
        rel="noreferrer"
        href={`https://${currentHost}.farkop.ru/services/ustanovka-farkopov/${filterParams?.marka?.[0]}/?model=${filterParams?.model?.[0]}`}
      >
        Открыть страницу установки
      </a>
    </div>
  ) : null;
}

function reduceWords(sentence: string) {
  const reduces = [
    ["Подключение", "Подкл."],
    ["подключением", "подкл."],
    ["электрики", "эл."],
    ["блоком", "бл."],
    ["согласования", "согл."],
  ];
  reduces.forEach((reduce) => {
    sentence = sentence.replace(reduce[0], reduce[1]);
  });
  return sentence;
}
